import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
// NgRx
import { ALERTS_MODAL_STATE_SLICE_KEY, alertsModal } from './state/alerts-modal.reducer';
// Modules
import { AutocompleteInPlaceModule } from 'SearchApp/ts/features/autocomplete-in-place/autocomplete-in-place.module';
import { ConfirmModalModule } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { FormsModule } from '@angular/forms';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { NotesAppModule } from 'NotesApp/ts/apps/notes-app/app.module';
import { SimpleDropdownModule } from 'NewAngular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { SharingModalModule } from 'NewAngular/features/components/modals/sharing-modal/sharing-modal.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
// Pipe
import { IsSharedWithOthersPipeModule } from 'SharingApp/ts/pipes/is-shared-with-others-pipe.module';
import { GetSharingTooltipMessagePipeModule } from 'SharingApp/ts/pipes/get-sharing-tooltip-message.module';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class AlertsModalModule {
}
AlertsModalModule.ɵfac = function AlertsModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AlertsModalModule)(); };
AlertsModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AlertsModalModule });
AlertsModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AutocompleteInPlaceModule,
        CommonModule,
        ConfirmModalModule,
        FeatureNeededModule,
        FormsModule,
        IconModule,
        LoadingSymbolModule,
        ModalBaseModule,
        NotesAppModule,
        SimpleDropdownModule,
        SingleSelectDropdownModule,
        SharingModalModule,
        StoreModule.forFeature(ALERTS_MODAL_STATE_SLICE_KEY, alertsModal),
        TooltipModule,
        IsSharedWithOthersPipeModule,
        GetSharingTooltipMessagePipeModule] });
